export { default } from "./CanvasIcon";
